import $windowConfig from '../WindowConfig.js'
import Api from '../fzs.http/Api.js'

function S4 () {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}

class Analysis {

  api = Api.bi
  uid = ''

  send (url, data) {
    try {
      const request = new XMLHttpRequest()
      const rnd = Math.floor(1234567890 * Math.random())
      request.open('get', this.api + url + '?rnd=' + rnd + '&data=' + JSON.stringify(data))
      request.send()
    } catch (e) {}
  }

  setAccount (clientId, channelId, uid) {
    this.uid = uid
    this.send('dt/reg-bi-user', {
      uid,
      client_id: clientId,
      channel_id: channelId,
      sdk_type: 'h5',
      sdk_version: '1.0'
    })
  }

  trackEvent (eventParam, propertyParam) {
    this.send('/dt/collect-user-event', {
      uid: this.uid,
      ...eventParam,
      property: {
        ...propertyParam
      }
    })
  }
}

let biUID = window.localStorage.getItem('bi-uid')

if (!biUID) {
  biUID = S4() + S4() + S4() + S4()
  window.localStorage.setItem('bi-uid', biUID)
}

const analysis = new Analysis()

// 调用事件收集接口前需要先调一次注册接口,传客户端id、渠道id
analysis.setAccount($windowConfig.clientId, $windowConfig.channelId, biUID)

window.$analysisBI = analysis

/**
 * 收集中行点击活动事件
 * 接口文档:https://rap.eoms.phone580.com/workspace/myWorkspace.action?projectId=35#8938
 * 用户从城市服务/薪酬管家进入页面埋点，示例：
 * window.$analysisBI.trackEvent({
      event_code: 'boc_click',
      current_page: encodeURIComponent(window.location.origin + window.location.pathname),
      time_begin: Date.now()
    }, {
      activityCode: $windowConfig.activityCode, // 活动编码
      channelId: $windowConfig.channelId,       // 渠道id
      channelName: $windowConfig.channelName,   // 渠道名称
      taskId: $windowConfig.taskId,             // 任务id
      userId: userInfo.userId,                  // 用户id
      sectionType: userInfo.sectionType,        // 专区类型（薪酬管家：FZSXCGJ，城市服务：FZSCSFW）
      custId: userInfo.customerId               // 网银客户号
    })
 */

